import React, { useState, useEffect } from "react";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
import Axios from "axios";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import TeasuryTable from "../../../components/Content/TeasuryTable";
import FileModalV2 from "../../../components/Modal/FileModal2";
import ItemWhModal from "../../../components/Modal/ItemWhsrtModal";

// Utils
// import {
//   formatDateOnChange,
//   formatDateToStringDate,
// } from "../../../../utils/DateUtils";
import {
  parseCurrency,
  getDataWithComp,
  getAlert,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";

const Main = ({
  name,
  onChangeMode,
  dataMasterList,
  dataDetailList,
  onSearchDateRange,
}) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whDocNo, setWhDocNo] = useState("");

  // จากคลัง
  const [fromWhId, setFromWhId] = useState("");
  const [fromWhName, setFromWhName] = useState("");
  const [remarkWhName, setRemarkWhName] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [formDetailList, setFormDetailList] = useState([]);
  console.debug("formDetailList", formDetailList);
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);

  // ไปคลัง
  const [toWhId, setToWhId] = useState("");
  const [toWhName, setToWhName] = useState("");

  const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [toDate, setToDate] = useState(moment().endOf("month"));
  const warehouse_Id = localStorage.getItem("WHID");
  const Emp_Position = localStorage.getItem("EmpPosition");

  // ตัวช่วยแปลงวันเป็น พ.ศ. รูปแบบ DD/MM/YYYY
  const fmtThaiDate = (d) => {
    if (!d) return "";
    const m = moment.isMoment(d) ? d.clone() : moment(d);
    return m.add(543, "years").format("DD/MM/YYYY");
  };

  const clearDetail = () => {
    setFilteredDetailList([]);
    setWhDocNo("");
    setFromWhId("");
    setFromWhName("");
    setToWhId("");
    setToWhName("");
    setRemarkWhName("");
    setSelectedFiles([]);
  };

  const onRowSelectItem = (
    itemsSelected,
    {
      fromDatex,
      toDatey,
      selectedWarehouseFrom,
      selectedWarehouseTo,
      selectedCreator,
      whDocRemarks,
      whDocRemarkMap,
      selectedWarehouseFrom2,
    }
  ) => {
    try {
      // ตัดซ้ำตาม WHDoc_Id (fallback: Item_Id)
      const map = new Map();
      for (const it of itemsSelected || []) {
        const id = it?.WHDoc_Id ?? it?.Item_Id;
        if (id != null && !map.has(id)) map.set(id, it);
      }
      const uniques = Array.from(map.values());

      // รวบรวม WHDoc_Id เป็นสตริงคั่นด้วย comma
      const idStr = uniques
        .map((d) => d?.WHDoc_Id ?? d?.Item_Id)
        .filter((v) => v != null && v !== "")
        .join(",");

      // ถ้าเอกสารมีหลายประเภท จะรวมชื่อประเภทแบบไม่ซ้ำคั่นด้วย comma
      const types = Array.from(
        new Set(
          uniques.map((d) => (d?.WHDocType_Name || "").trim()).filter(Boolean)
        )
      );
      const typeStr = types.length === 0 ? "" : types.join(", ");

      // ช่วงวันที่ (พ.ศ.)
      const dateStr = `${fmtThaiDate(fromDatex)} - ${fmtThaiDate(toDatey)}`;

      // อ็อบเจ็กต์ผลลัพธ์ตามฟอร์แมตที่ต้องการ
      const payload = {
        WHDoc_Id: idStr,
        WHDocType_Name: typeStr || "คลังโรงงาน", // ถ้าต้องการบังคับค่าคงที่ ให้ใส่ตรงนี้
        Date:
          dateStr === " - "
            ? `${fmtThaiDate(moment().startOf("month"))} - ${fmtThaiDate(
                moment().endOf("month")
              )}`
            : dateStr,
        selectedCreator: selectedCreator || "ทั้งหมด",
        whDocRemarks: whDocRemarks || "ทั้งหมด",
        whDocRemarkMap: whDocRemarkMap || {},
        selectedWarehouseFrom: selectedWarehouseFrom2 || "ทั้งหมด",
        acc: localStorage.getItem("name") || "system",
      };
      console.debug("onRowSelectItem payload =>", payload);

      const map2 = new Map();
      for (const it of itemsSelected || []) {
        const id = it?.WHDoc_Id ?? it?.Item_Id;
        if (id != null && !map2.has(id)) map2.set(id, it);
      }
      const updated = Array.from(map2.values()).map((d) => ({
        WHDoc_Id: d?.WHDoc_Id ?? d?.Item_Id ?? null,
        WHDocType_Name: d?.WHDocType_Name ?? "",
        fromDate: fromDatex ? fromDatex.toISOString() : null,
        toDate: toDatey ? toDatey.toISOString() : null,
      }));
      setFormDetailList(updated);

      // ถ้าสตรีมเดิมของคุณคาดหวัง "ออบเจ็กต์เดียว" ให้ set แบบนี้:
      // setFormDetailList(payload);

      // ถ้าคาดหวังเป็น "อาร์เรย์" ให้ใช้แบบนี้แทน:
      // setFormDetailList([payload]);
      console.debug("selectedItemType", selectedItemType);
      if (selectedItemType === 3) {
        getReport("SUM_WHDOC_3", payload);
      } else if (selectedItemType === 2) {
        getReport("SUM_WHDOC_2", payload);
      } else {
        getReport("SUM_WHDOC_1", payload);
      }

      handleItemClose();
    } catch (e) {
      getAlert("FAILED", e?.message || String(e));
    }
  };

  const getDefaultItemType = () => {
    const mode = localStorage.getItem("TreasuryDocumentsMode");
    switch (mode) {
      case "FA":
        return 1;
      case "FT":
        return 2;
      case "WDP":
        return 3;
      default:
        return 1; // ค่า default ถ้าไม่มีใน localStorage
    }
  };

  const [selectedItemType, setSelectedItemType] = useState(
    getDefaultItemType()
  );

  const handleChangeDate = (value, name) => {
    const rawValue = moment.isMoment(value)
      ? value.format("YYYY-MM-DD")
      : String(value || "");

    if (!rawValue) return;

    // แปลงปี พ.ศ. ➜ ค.ศ. (ถ้าปีมากกว่า 2500)
    const [year, month, day] = rawValue.split("-");
    const convertedDate = `${
      parseInt(year, 10) > 2500 ? parseInt(year, 10) - 543 : year
    }-${month}-${day}`;

    if (name === "fromDate") {
      setFromDate(convertedDate);
    } else {
      setToDate(convertedDate);
    }
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };

  const onRowSelected = async (fromData) => {
    try {
      setIsLoadingDetails(true);
      
      // ⚡ Performance: Fetch details on-demand instead of filtering pre-loaded data
      const filteredDetail = await getDataWithComp(
        "API_1002_WHDOC_D",
        `AND WHDoc_Id = ${fromData.WHDoc_Id} ORDER BY Line ASC`
      );

      if (filteredDetail && filteredDetail.length > 0) {
        setFilteredDetailList(filteredDetail);
        
        // Fetch attachments
        const files = await getDataWithComp(
          "Upload_File_List",
          `AND DocCode_ID = ${
            selectedItemType === 1 ? 16 : selectedItemType === 2 ? 17 : 18
          } AND Doc_ID = ${fromData.WHDoc_Id} AND File_Status = 'Y'`
        );
        if (files && files.length > 0) {
          const formattedFiles = files.map((file) => ({
            F_Id: file.F_Id,
            fileName: file.File_Name,
            File_Url: file.File_Name,
            uploadDate: file.Upload_Date,
            uploadBy: file.Upload_By,
          }));
          setSelectedFiles(formattedFiles);
        } else {
          setSelectedFiles([]);
        }
        
        // Set warehouse info
        setFromWhId(filteredDetail[0]?.F_WH_Id);
        setFromWhName(filteredDetail[0]?.F_WH_Name);
        setToWhId(filteredDetail[0]?.T_WH_Id);
        setToWhName(filteredDetail[0]?.T_WH_Name);
        setRemarkWhName(filteredDetail[0]?.WHDoc_Remark);
      } else {
        setFilteredDetailList([]);
        setSelectedFiles([]);
      }

      setWhDocNo(fromData.WHDoc_No);
    } catch (error) {
      console.error("Error fetching details:", error);
      getAlert("FAILED", "ไม่สามารถโหลดข้อมูลรายละเอียดได้");
      setFilteredDetailList([]);
      setSelectedFiles([]);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const handleSearch = async () => {
    if (onSearchDateRange) {
      await onSearchDateRange({ fromDate, toDate });
    }
    setSearchItemTerm(searchInputValue || "");
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const parseDocCreatedDate = (value) => {
    if (!value) return null;

    const normalizedValue = String(value)
      .trim()
      .replace(/([+-]\d{2}:?\d{2}|Z)$/i, "");

    const parsed = moment(normalizedValue, [
      "YYYY-MM-DD HH:mm:ss.SSS",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ss.SSS",
      "YYYY-MM-DDTHH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "DD/MM/YYYY HH:mm:ss",
      "DD-MM-YYYY HH:mm",
      "DD/MM/YYYY HH:mm",
      "YYYY-MM-DD",
    ], true);

    if (parsed.isValid()) return parsed;

    const fallback = moment(normalizedValue);
    return fallback.isValid() ? fallback : null;
  };

  const formatCreatedDateForDisplay = (value) => {
    const parsed = parseDocCreatedDate(value);
    return parsed && parsed.isValid()
      ? parsed.clone().add(543, "years").format("DD-MM-YYYY HH:mm")
      : "-";
  };

  const filterDataByDate = (data) => {
    const from = fromDate ? moment(fromDate).format("YYYY-MM-DD") : null;
    const to = toDate ? moment(toDate).format("YYYY-MM-DD") : null;

    const docDate = parseDocCreatedDate(data?.WHDoc_CreatedDate);

    if (!docDate || !docDate.isValid()) {
      return false;
    }

    const docDateOnly = docDate.format("YYYY-MM-DD");

    return (
      (!from || docDateOnly >= from) &&
      (!to || docDateOnly <= to)
    );
  };

  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const searchTerm = (searchItemTerm || "").toLowerCase();

    const matchesItemSearchTerm =
      (data?.WHDoc_No || "").toLowerCase().includes(searchTerm) ||
      (data?.WHDocType_Name || "").toLowerCase().includes(searchTerm);

    // ตรวจสอบการกรองตามประเภทเอกสาร
    const matchesItemType = selectedItemType
      ? String(data?.WHDoc_Type) === String(selectedItemType)
      : true;

    // ตรวจสอบการกรองตามวันที่
    const matchesDateRange = filterDataByDate(data);

    return matchesItemSearchTerm && matchesItemType && matchesDateRange;
  });
  console.debug("filteredItemData", filteredItemData);

  useEffect(() => {
    if (!onSearchDateRange) return;

    onSearchDateRange({ fromDate, toDate });
    clearDetail();
  }, [fromDate, toDate]);

  const handleFileSelection = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const filePromises = files.map((file, index) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: e.target.result,
            isPending: true,
            displayName: file.name,
          });
        };

        reader.onerror = () => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: URL.createObjectURL(file),
            isPending: true,
            displayName: file.name,
            useObjectUrl: true,
          });
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises)
      .then((processedFiles) => {
        const updatedFiles = [...selectedFiles, ...processedFiles];
        setSelectedFiles(updatedFiles);
        setShowFileModal(true); // ✅ แสดง modal ได้เลย ไม่ต้องเรียก handleInputFileChange
      })
      .catch((error) => {});

    event.target.value = "";
  };

  const handleBeforeUploadAttach = async () => {
    // URL ที่ไม่ต้องการให้มีการอัปโหลดซ้ำ
    const INVALID_BASE_URL =
      "https://23samuiice2024.s3.ap-southeast-1.amazonaws.com/SO_H/";

    // ดึงไฟล์ที่อัปโหลดแล้ว (isUploaded = true)
    const uploadedFileNames = new Set(
      selectedFiles
        .filter((file) => file.isUploaded)
        .map((file) => file.name?.toLowerCase())
    );

    // เลือกไฟล์ที่ยังไม่ได้อัปโหลด
    const filesToUpload = selectedFiles.filter((file) => {
      const isPending = file.isPending && !file.isUploaded;
      const isNotDuplicate = !uploadedFileNames.has(file.name?.toLowerCase());
      const isValidName =
        typeof file.name === "string" &&
        !file.name.startsWith(INVALID_BASE_URL);

      return isPending && isNotDuplicate && isValidName;
    });

    if (filesToUpload.length === 0) {
      getAlert("WARNING", "ไม่มีไฟล์ใหม่สำหรับอัปโหลด หรือไฟล์ซ้ำ/ไม่ถูกต้อง");
      return;
    }

    try {
      const filesWithBase64 = filesToUpload.map((file) => ({
        id: file.id,
        name: file.name,
        type: file.type,
        size: file.size,
        dataUrl: file.dataUrl,
        displayName: file.displayName || file.name,
      }));

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload-file`,
        {
          comp_id: localStorage.getItem("company"),
          doc_id: filteredDetailList[0]?.WHDoc_Id,
          DocCode_ID:
            selectedItemType === 1 ? 16 : selectedItemType === 2 ? 17 : 18,
          upload_by: localStorage.getItem("name") || "system",
          file_status: "Y",
          files: filesWithBase64,
          doc_no_ref: null,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      const result = response.data;

      if (!result || result.status !== "SUCCESS") {
        throw new Error(result.message || "อัปโหลดล้มเหลว");
      }

      // อัปเดตสถานะไฟล์
      const updatedFiles = selectedFiles.map((file) => {
        const justUploaded = filesToUpload.find(
          (f) => f.name?.toLowerCase() === file.name?.toLowerCase()
        );
        return justUploaded
          ? { ...file, isUploaded: true, isPending: false }
          : file;
      });

      setSelectedFiles(updatedFiles);
      getAlert("OK", "อัปโหลดไฟล์สำเร็จ");
      setShowFileModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Upload error:", error);
      getAlert(
        "FAILED",
        error.response?.data?.message ||
          error.message ||
          "เกิดข้อผิดพลาดในการอัปโหลดไฟล์"
      );
    }
  };

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const mode = localStorage.getItem("TreasuryDocumentsMode");
    switch (mode) {
      case "FA":
        setSelectedItemType(1);
        break;
      case "FT":
        setSelectedItemType(2);
        break;
      case "WDP":
        setSelectedItemType(3);
        break;
      default:
        setSelectedItemType(1);
    }
  }, []);

  useEffect(() => {
    console.debug("filteredDetailList updated =>", filteredDetailList);
  }, [filteredDetailList]);

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: name, url: "/treasury-documents" },
        ]}
      />
      <div
        className="container-fluid card py-3"
        style={{ maxHeight: "85vh", overflowY: "auto" }}
      >
        {isSmallScreen < 1749 ? (
          <div>
            <div
              className="row mb-2 align-items-center"
              style={
                isSmallScreen < 1672
                  ? {
                      display: "grid",
                      gridTemplateColumns: "500px auto  ",
                      // justifyContent: "space-between",
                    }
                  : {
                      display: "grid",
                      gridTemplateColumns: "500px auto auto",
                      // justifyContent: "space-between",
                    }
              }
            >
              <div className="">
                <button
                  className="btn text-white"
                  onClick={() => onChangeMode("FA")}
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                  disabled={warehouse_Id === "3" && Emp_Position !== "1"}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                  สร้างใบปรับปรุงสินค้า
                </button>
                <button
                  className="btn text-white mx-3"
                  onClick={() => onChangeMode("FT")}
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                  disabled={warehouse_Id === "3" && Emp_Position !== "1"}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                  สร้างใบโอนย้าย
                </button>

                <button
                  className="btn text-white"
                  onClick={() => onChangeMode("WDP")}
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                  disabled={warehouse_Id === "3" && Emp_Position !== "1"}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                  สร้างใบเบิกสินค้า
                </button>
              </div>
              <div
                className="input-group"
                style={{
                  display: "grid",
                  gridTemplateColumns: "220px 360px auto",
                  columnGap: "12px",
                  alignItems: "center",
                }}
              >
                <div className="">
                  <div className="input-group" style={{ width: "260px" }}>
                    <span className="input-group-text">Search</span>
                    <input
                      type="text"
                      className="form-control"
                      value={searchInputValue || ""}
                      onChange={(e) => setSearchInputValue(e.target.value)}
                      onKeyDown={handleSearchKeyDown}
                    />
                    <button
                      type="button"
                      className="btn text-white"
                      onClick={handleSearch}
                      style={{
                        backgroundColor: "rgb(239, 108, 0)",
                        borderColor: "rgb(239, 108, 0)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ค้นหา
                    </button>
                  </div>
                </div>

                <div className="" style={{ width: "350px" }}>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {[
                      { value: 1, label: "ใบปรับสินค้า" },
                      { value: 2, label: "ใบโอนย้าย" },
                      { value: 3, label: "ใบเบิก" },
                    ].map((option) => {
                      const active = selectedItemType === option.value;
                      return (
                        <button
                          key={option.value}
                          type="button"
                          className="btn"
                          onClick={() => {
                            clearDetail();
                            setSelectedItemType(option.value);
                          }}
                          style={{
                            backgroundColor: active ? "rgb(239, 108, 0)" : "#fff3e0",
                            color: active ? "#fff" : "rgb(239, 108, 0)",
                            border: "1px solid rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "8px 14px",
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          {option.label}
                        </button>
                      );
                    })}
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto auto",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      width: "100%",
                      gridTemplateColumns: "210px 210px",
                      gap: "8px",
                      alignItems: "end",
                    }}
                  >
                    <div className="">
                      <div
                        className="input-group"
                        style={{
                          width: "100%",
                          display: "grid",
                          gridTemplateColumns: "75px 110px",
                        }}
                      >
                        <div>
                          <span className="input-group-text">
                            จากวันที่สร้าง
                          </span>
                        </div>
                        <div>
                          <Datetime
                            name="fromDate"
                            value={
                              fromDate
                                ? moment(fromDate).add(543, "years")
                                : null
                            }
                            onChange={(date) =>
                              handleChangeDate(
                                moment(date).subtract(543, "years"),
                                "fromDate"
                              )
                            }
                            dateFormat="DD-MM-YYYY"
                            timeFormat={false}
                            inputProps={{ readOnly: true, disabled: false }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <div
                        className="input-group"
                        style={{
                          width: "100%",
                          display: "grid",
                          gridTemplateColumns: "50px 110px",
                        }}
                      >
                        <div>
                          <span className="input-group-text">
                            ถึงวันที่สร้าง
                          </span>
                        </div>
                        <div>
                          <Datetime
                            name="toDate"
                            value={
                              toDate ? moment(toDate).add(543, "years") : null
                            }
                            onChange={(date) =>
                              handleChangeDate(
                                moment(date).subtract(543, "years"),
                                "toDate"
                              )
                            }
                            dateFormat="DD-MM-YYYY"
                            timeFormat={false}
                            inputProps={{ readOnly: true, disabled: false }}
                          />
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div style={isSmallScreen < 1672 ? { marginTop: "10px" } : {}}>
                <div className="">
                  <button
                    className="btn text-white"
                    onClick={() => handleItemShow()}
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      whiteSpace: "nowrap",
                      padding: "10px",
                      fontSize: "15px",
                    }}
                    // disabled={warehouse_Id === "3" && Emp_Position !== "1"}
                  >
                    <i className="fa fa-print me-2"></i>
                    {selectedItemType === 3
                      ? "พิมม์สรุปใบเบิกสินค้า"
                      : selectedItemType === 2
                      ? "พิมพ์สรุปใบโอนย้าย"
                      : "พิมพ์สรุปใบปรับปรุงสินค้า"}
                  </button>
                  <ItemWhModal
                    showItemModal={showItemModal}
                    handleItemClose={handleItemClose}
                    formDetailList={formDetailList}
                    onRowSelectItem={onRowSelectItem}
                    dataList={filteredItemData}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="row mb-2 align-items-center"
            style={{
              display: "grid",
              gridTemplateColumns: "500px 500px 360px auto",
              columnGap: "12px",
            }}
          >
            <div className="">
              <button
                className="btn text-white"
                onClick={() => onChangeMode("FA")}
                style={{
                  backgroundColor: "rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "10px",
                  fontSize: "15px",
                }}
                disabled={warehouse_Id === "3" && Emp_Position !== "1"}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                สร้างใบปรับปรุงสินค้า
              </button>
              <button
                className="btn text-white mx-3"
                onClick={() => onChangeMode("FT")}
                style={{
                  backgroundColor: "rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "10px",
                  fontSize: "15px",
                }}
                disabled={warehouse_Id === "3" && Emp_Position !== "1"}
              >
                <i className="fa fa-plus" aria-hidden="true"></i> สร้างใบโอนย้าย
              </button>

              <button
                className="btn text-white"
                onClick={() => onChangeMode("WDP")}
                style={{
                  backgroundColor: "rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "10px",
                  fontSize: "15px",
                }}
                disabled={warehouse_Id === "3" && Emp_Position !== "1"}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                สร้างใบเบิกสินค้า
              </button>
            </div>

            <div className="">
              <div className="input-group" style={{ width: "480px" }}>
                <span className="input-group-text">Search</span>
                <input
                  type="text"
                  className="form-control"
                  value={searchInputValue || ""}
                  onChange={(e) => setSearchInputValue(e.target.value)}
                  onKeyDown={handleSearchKeyDown}
                />
                <button
                  type="button"
                  className="btn text-white"
                  onClick={handleSearch}
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    borderColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                  }}
                >
                  ค้นหา
                </button>
              </div>
            </div>

            <div className="" style={{ width: "350px" }}>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {[
                  { value: 1, label: "ใบปรับสินค้า" },
                  { value: 2, label: "ใบโอนย้าย" },
                  { value: 3, label: "ใบเบิก" },
                ].map((option) => {
                  const active = selectedItemType === option.value;
                  return (
                    <button
                      key={option.value}
                      type="button"
                      className="btn"
                      onClick={() => {
                        clearDetail();
                        setSelectedItemType(option.value);
                      }}
                      style={{
                        backgroundColor: active ? "rgb(239, 108, 0)" : "#fff3e0",
                        color: active ? "#fff" : "rgb(239, 108, 0)",
                        border: "1px solid rgb(239, 108, 0)",
                        whiteSpace: "nowrap",
                        padding: "14px 14px",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {option.label}
                    </button>
                  );
                })}
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "grid",
                  width: "100%",
                  gridTemplateColumns: "210px 210px",
                  gap: "8px",
                  alignItems: "end",
                }}
              >
                <div className="">
                  <div
                    className="input-group"
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "90px 110px",
                    }}
                  >
                    <div>
                      <span className="input-group-text">จากวันที่สร้าง</span>
                    </div>
                    <div>
                      <Datetime
                        name="fromDate"
                        value={
                          fromDate ? moment(fromDate).add(543, "years") : null
                        }
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "fromDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                </div>

                <div className="">
                  <div
                    className="input-group"
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "80px 110px",
                    }}
                  >
                    <div>
                      <span className="input-group-text">ถึงวันที่สร้าง</span>
                    </div>
                    <div>
                      <Datetime
                        name="toDate"
                        value={toDate ? moment(toDate).add(543, "years") : null}
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "toDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                </div>

              </div>

              <div className="">
                <button
                  className="btn text-white"
                  onClick={() => handleItemShow()}
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                  // disabled={warehouse_Id === "3" && Emp_Position !== "1"}
                >
                  <i className="fa fa-print me-2"></i>
                  {selectedItemType === 3
                    ? "พิมม์สรุปใบเบิกสินค้า"
                    : selectedItemType === 2
                    ? "พิมพ์สรุปใบโอนย้าย"
                    : "พิมพ์สรุปใบปรับปรุงสินค้า"}
                </button>
                <ItemWhModal
                  showItemModal={showItemModal}
                  handleItemClose={handleItemClose}
                  formDetailList={formDetailList}
                  onRowSelectItem={onRowSelectItem}
                  dataList={filteredItemData}
                  selectedItemType={selectedItemType}
                  defaultSelectAll={true}
                />
              </div>
            </div>
          </div>
        )}

        <hr />
        <div className="row ">
          <div
            className="col-6 mb-1"
            style={{ borderRight: "2px solid #c7c8c9" }}
          >
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "1%" }}>
                      เลขเอกสาร
                    </th>
                    <th className="text-center" style={{ width: "1%" }}>
                      ประเภท
                    </th>
                    <th className="text-center" style={{ width: "2%" }}>
                      คลังที่ปรับปรุง
                    </th>
                    <th className="text-center" style={{ width: "3%" }}>
                      วันที่สร้าง
                    </th>
                    <th className="text-center" style={{ width: "5%" }}>
                      หมายเหตุ
                    </th>

                    <th className="text-center" style={{ width: "5%" }}>
                      ชื่อผู้สร้าง
                    </th>
                    {selectedItemType === 3 && (
                      <th className="text-center" style={{ width: "5%" }}>
                        เลขเอกสารอ้างอิง
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredItemData.length > 0 ? (
                    filteredItemData.map((data, index) => (
                      <tr
                        key={data.WHDoc_Id || index + 1}
                        onClick={() => onRowSelected(data)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-center">{data.WHDoc_No}</td>
                        <td className="text-center">{data.WHDocType_Name}</td>
                        <td className="text-center">{data.F_WH_Name}</td>
                        <td className="text-center">
                          {formatCreatedDateForDisplay(data?.WHDoc_CreatedDate)}
                        </td>
                        <td className="text-left">{data.WHDoc_Remark}</td>
                        <td className="text-center">{data.WHDoc_CreatedBy}</td>
                        {selectedItemType === 3 && (
                          <td className="text-center"></td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-6 mb-3">
            {isLoadingDetails ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {filteredDetailList.length !== 0 && (
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p
                  className="card-title mb-0"
                  style={{ width: "50%", fontSize: "14px" }}
                >
                  เอกสารเลขที่: {whDocNo}
                  {whDocNo.substring(0, 3) === "TNS" &&
                    selectedItemType === 2 && (
                      <>
                        <span>
                          {" "}
                          จากคลัง: {fromWhName} ไปยังคลัง: {toWhName}{" "}
                          {remarkWhName ? `หมายเหตุ: ${remarkWhName}` : ""}
                        </span>
                      </>
                    )}
                  {selectedItemType && selectedItemType !== 2 && (
                    <>
                      <span> {fromWhName ? `คลัง: ${fromWhName}` : ""}</span>
                      <span>
                        {" "}
                        {remarkWhName ? `หมายเหตุ: ${remarkWhName}` : ""}
                      </span>
                    </>
                  )}
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div>
                    {selectedFiles.length > 0 ? (
                      <div>
                        <button
                          className="btn text-white"
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "12px",
                            fontSize: "15px",
                            // borderRadius: "8px",
                            border: "none",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          // disabled={disabled}
                          onClick={
                            () => setShowFileModal(true)
                            // document.getElementById("file-upload-input").click()
                          }
                        >
                          <i className="fa fa-paperclip"></i>
                          ดูไฟล์ ({selectedFiles?.length})
                        </button>
                      </div>
                    ) : (
                      <div>
                        <input
                          type="file"
                          multiple
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.mp4,.avi,.mov,.mp3,.wav"
                          onChange={handleFileSelection}
                          style={{ display: "none" }}
                          id="file-upload-input"
                        />
                        <button
                          className="btn text-white"
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            whiteSpace: "nowrap",
                            padding: "11px 21px",
                            fontSize: "15px",
                            // borderRadius: "8px",
                            border: "none",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          // disabled={disabled}
                          onClick={() =>
                            document.getElementById("file-upload-input").click()
                          }
                        >
                          <i className="fa fa-paperclip"></i>
                          แนบไฟล์
                        </button>
                      </div>
                    )}
                  </div>
                  <div>
                    {selectedItemType === 1 ? (
                      <button
                        // disabled={true}
                        className="btn d-flex align-items-center text-white"
                        style={{
                          backgroundColor: "rgb(239, 108, 0)",
                          fontSize: "16px",
                        }}
                        onClick={() => getReport("WHDOC", whDocNo)}
                      >
                        <i className="fa fa-print me-2"></i>
                        พิมพ์ใบปรับยอด
                      </button>
                    ) : selectedItemType === 2 ? (
                      <button
                        // disabled={true}
                        className="btn d-flex align-items-center text-white"
                        style={{
                          backgroundColor: "rgb(239, 108, 0)",
                          fontSize: "16px",
                        }}
                        onClick={() => getReport("WHDOC", whDocNo)}
                      >
                        <i className="fa fa-print me-2"></i>
                        พิมพ์ใบโอนย้าย
                      </button>
                    ) : (
                      <button
                        // disabled={true}
                        className="btn d-flex align-items-center text-white"
                        style={{
                          backgroundColor: "rgb(239, 108, 0)",
                          fontSize: "16px",
                        }}
                        onClick={() => getReport("WHDOC", whDocNo)}
                      >
                        <i className="fa fa-print me-2"></i>
                        พิมพ์ใบเบิก
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
            <TeasuryTable dataList={filteredDetailList} />
            <FileModalV2
              mode="U" // โหมดดูอย่างเดียว
              showViewAttachModal={showFileModal}
              setShowViewAttachModal={setShowFileModal}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              selectedRecFiles={[]}
              openUploadAttach={openUploadAttach}
              handleRemoveImage={handleRemoveImage}
              handleBeforeUploadAttach={handleBeforeUploadAttach}
            />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
